import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { usePageMeta } from '../lib/usePageMeta';
export function Terms() {
  usePageMeta({
    title: 'Términos y Condiciones — Más Años Juntos',
    description: 'Términos y condiciones de uso de Más Años Juntos.'
  });
  return <div className="min-h-screen bg-cream-light font-sans text-gray-900" data-id="element-362">
      <header className="bg-white border-b border-sage-light/30" data-id="element-363">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between" data-id="element-364">
          <Link to="/" className="inline-flex items-center text-sage-dark hover:text-terracotta transition-colors text-sm font-medium" data-id="element-365">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-366" />
            Volver al inicio
          </Link>
          <span className="font-serif font-bold text-lg text-gray-900" data-id="element-367">
            MÁS AÑOS JUNTOS
          </span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-368">
        <h1 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-4" data-id="element-369">
          Términos y Condiciones
        </h1>
        <p className="text-sm text-gray-500 mb-12" data-id="element-370">
          Última actualización: Mayo de 2026
        </p>

        <div className="prose prose-lg max-w-none space-y-8 text-gray-700 leading-relaxed" data-id="element-371">
          <section data-id="element-372">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-373">
              1. Sobre este sitio
            </h2>
            <p data-id="element-374">
              Al acceder y utilizar esta página, aceptas las condiciones aquí
              descritas. Esta web ofrece un producto digital educativo titulado
              "Más Años Juntos", que contiene información, guías y recursos
              relacionados con la nutrición natural y la convivencia con
              mascotas.
            </p>
          </section>

          <section data-id="element-375">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-376">
              2. Naturaleza del producto
            </h2>
            <p data-id="element-377">
              "Más Años Juntos" es un producto 100% digital de carácter
              informativo y educativo. Su contenido está pensado para
              acompañarte en decisiones de bienestar para tu mascota, pero no
              sustituye la consulta veterinaria profesional. Cualquier cambio
              significativo en la alimentación o el cuidado de tu animal debería
              ser conversado con un profesional veterinario de confianza.
            </p>
          </section>

          <section data-id="element-378">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-379">
              3. Compra y acceso
            </h2>
            <p data-id="element-380">
              Al completar la compra recibirás acceso inmediato al material
              digital, incluyendo el libro principal y los bonos asociados. El
              acceso se entrega al correo electrónico proporcionado al momento
              de la compra. Te recomendamos guardar este correo y descargar el
              contenido en un dispositivo seguro.
            </p>
          </section>

          <section data-id="element-381">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-382">
              4. Garantía de satisfacción
            </h2>
            <p data-id="element-383">
              Ofrecemos una garantía de satisfacción de 30 días desde la fecha
              de compra. Si por algún motivo no estás conforme con el material,
              puedes solicitar el reembolso escribiéndonos al correo de
              contacto. Procesaremos tu solicitud dentro de los días hábiles
              siguientes.
            </p>
          </section>

          <section data-id="element-384">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-385">
              5. Uso del contenido
            </h2>
            <p data-id="element-386">
              El contenido adquirido es para uso personal. Te pedimos que no
              redistribuyas, copies ni compartas el material con terceros. Cada
              acceso es individual y nos ayuda a seguir creando contenido de
              calidad para la comunidad.
            </p>
          </section>

          <section data-id="element-387">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-388">
              6. Resultados
            </h2>
            <p data-id="element-389">
              Los resultados varían entre una mascota y otra. La información
              ofrecida está basada en buenas prácticas de nutrición natural y
              convivencia, pero no garantizamos resultados específicos. Cada
              animal es único y responde de forma distinta a los cambios.
            </p>
          </section>

          <section data-id="element-390">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-391">
              7. Contacto
            </h2>
            <p data-id="element-392">
              Si tienes cualquier consulta sobre estos términos o sobre el
              producto, puedes escribirnos a través del correo de contacto que
              aparece en el correo de confirmación de tu compra. Respondemos
              dentro de los días hábiles.
            </p>
          </section>

          <section data-id="element-393">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-394">
              8. Modificaciones
            </h2>
            <p data-id="element-395">
              Podemos actualizar estos términos ocasionalmente para reflejar
              mejoras en el producto o en el servicio. La fecha de la última
              actualización siempre estará visible en la parte superior de esta
              página.
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-sage-light/40" data-id="element-396">
          <Link to="/" className="inline-flex items-center text-sage-dark hover:text-terracotta transition-colors font-medium" data-id="element-397">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-398" />
            Volver al inicio
          </Link>
        </div>
      </main>
    </div>;
}